<mat-tab-group>
  <mat-tab [label]="'igo.context.shareMap.shareWithUrl' | translate">
    <igo-share-map-url [map]="map"></igo-share-map-url>
  </mat-tab>
</mat-tab-group>
